























import {
    defineComponent,
    PropType,
} from '@vue/composition-api';
import {
    SanitizedHtml,
    SdsAlert,
} from '@superbet-group/web.lib.ui-components';

type States = 'initial' | 'failed';
type StateConfig = {
    alertStatus: 'info' | 'warning' | 'danger' | 'success';
    title: string;
    message: string;
};

export default defineComponent({
    name: 'KycStatusAlert',
    props: {
        status: {
            type: String as PropType<'initial' | 'failed'>,
            required: false,
            default: 'initial',
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
    },
    setup(props) {
        const stateConfig: Record<States, StateConfig> = {
            initial: {
                alertStatus: 'info',
                title: 'pam.identityVerificationPrompt.status.intro.title',
                message: 'pam.identityVerificationPrompt.status.intro.message',
            },
            failed: {
                alertStatus: 'warning',
                title: 'pam.identityVerificationPrompt.status.failed.title',
                message: 'pam.identityVerificationPrompt.status.failed.message',
            },
        };

        return {
            statusConfig: stateConfig[props.status],
        };
    },
    components: {
        SdsAlert,
        SanitizedHtml,
    },
});
